<template>
  <div class="initform--background data--center"></div>
  <process2fa></process2fa>
  <!--  <div v-if="!isTwoFactorAuthenticationProcess" class="initform__card data&#45;&#45;center">-->
  <div v-if="loginUserFormStatusData === LoginUserFormStatus.Login"
       class="initform__card initform__card__size data--center">
    <div class="initform__wrapper">
      <!--      <img class="initform__logo" src="../../assets/img/ingeteam_logo.png"/>-->
      <img class="initform__logo" src="../../assets/img/IS_Planner_vertical.png"/>
      <LoginUserForm/>
    </div>
  </div>
  <div v-if="loginUserFormStatusData === LoginUserFormStatus.RecoverUserPwd"
       class="initform__card registerform__card__size data--center">
    <RecoverUserPwdForm/>
  </div>
  <div v-if="loginUserFormStatusData === LoginUserFormStatus.RegisterUser"
       class="initform__card registerform__card__size data--center">
    <RegisterUserForm/>
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, ref} from "vue";
import {useStore} from "vuex";
import {LoginUserFormStatus, UserEmailPassword} from "@/types/User";
import RecoverUserPwdForm from "@/components/Login/RecoverUserPwdForm.vue";
import RegisterUserForm from "@/components/Login/RegisterUserForm.vue";
import LoginUserForm from "@/components/Login/LoginUserForm.vue";
import {AuthenticatorValidationStatus} from "@/types/autenticationresult";
import Process2fa from "@/components/TwoFactorAuth/process2fa.vue";

export default defineComponent({
  name: 'InitForm',
  components: {Process2fa, RegisterUserForm, RecoverUserPwdForm, LoginUserForm},
  setup() {
    const store = useStore();

    const loginUserFormStatusData = computed(() => {
      return store.getters.getLoginUserFormStatus;
    });

    const twofactorauthprocess = computed(() => {
      return store.getters.getTwoFactorAuthStep;
    });

    const isTwoFactorAuthenticationProcess = computed(() => {
      return twofactorauthprocess.value !== AuthenticatorValidationStatus.None;
    });


    return {
      loginUserFormStatusData,
      LoginUserFormStatus,
      isTwoFactorAuthenticationProcess
    }
  }
});
</script>

<style scoped>
.initform--background {
  background-image: url("../../assets/img/fondo1.png");
  /*background-image: url("../../assets/img/isplanner-login.jpg");*/
  /*height: calc(99.9vh - var(--navbar-height));*/
  height: 93vh;
  width: 100%;
  opacity: 0.5;
}

.initform__card__size {
  height: 500px;
  width: 500px;
}

.registerform__card__size {
  height: 700px;
  width: 700px;
}

.initform__card {
  background-color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* Moves the element back by half its own width and height */
  padding: 1rem;
}

.initform__wrapper {
  margin-left: auto;
  margin-right: auto;
  width: 95%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.initform__logo {
  /*height: 25%;
  width: 25%;*/
  height: 4rem;
  width: 10rem;
  margin-bottom: 1rem;
}

.initform__wrapper div p {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.initform__wrapper input {
  border: 1px solid var(--unnamed-color-707070);
  width: 21.625em;
  height: 3.063em;
  margin-bottom: 1rem;
}

</style>
